import { Injectable } from '@angular/core';
import { Constants } from '../../app/app-constants';

@Injectable()
export class TokenService {

  constants: any = Constants;
  private iss = {
    login: `${this.constants.api}/login`,
    signup: `${this.constants.api}/signup`
  };

  constructor() { }

  handle(token) {
    this.set(token);
  }

  set(token) {
    localStorage.setItem('token', token);
  }

  get() {
    return localStorage.getItem('token');
  }

  remove() {
    localStorage.removeItem('token');
  }

  isValid() {

    const token = this.get();
    if (token) {
      const payload = this.payload(token);
      if (payload) {
        return true
      }
    }
    return false;
  }

  payload(token) {
    const payload = token.split('.')[1];
    return this.decode(payload);
  }

  decode(payload) {
    return JSON.parse(atob(payload));
  }

  loggedIn() {
    return this.isValid();
  }
}
